import { render, staticRenderFns } from "./cUserDetail.vue?vue&type=template&id=b450e648&scoped=true"
import script from "./cUserDetail.vue?vue&type=script&lang=js"
export * from "./cUserDetail.vue?vue&type=script&lang=js"
import style0 from "./cUserDetail.vue?vue&type=style&index=0&id=b450e648&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b450e648",
  null
  
)

export default component.exports